// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5cec3741","498":"f627312e","703":"c5a7bfd8"}[chunkId] + ".chunk.js";
};